<template>
  <div
    :class="['map-wrap', {'shift-right': shiftMap}]"
    @click="clearDestinations"
  >
    <svg
      :viewBox="viewBox"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      height="100%"
      width="100%"
    >
      <map-header :visualizationLayerType="visualizationLayerType" :mapSize="mapAdjustSize" v-if="isShowVisualizationLayer" />

      <!-- NOTE: 地図画像 -->
      <map-image />

    </svg>

    <svg
      :viewBox="viewBox"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      height="100%"
      width="100%"
      class="visualizationPinLayer"
    >
      <svg-defs />

      <!-- NOTE: 見える化レイヤー -->
      <visualization-layer-light v-if="visualizationLayerType == 'light'" />
      <visualization-layer-temperature v-if="visualizationLayerType == 'temperature'" />
      <visualization-layer-humidity v-if="visualizationLayerType == 'humidity'" />
      <visualization-layer-eco2 v-if="visualizationLayerType == 'eco2'" />
      <visualization-layer-sound v-if="visualizationLayerType == 'sound'" />
      <visualization-layer-wind-speed v-if="visualizationLayerType == 'wind_speed'" />

      <!-- NOTE: サイネージの場所ピン -->
      <image
        width="90"
        height="99"
        :transform="`translate(17.02, -25.68) scale(${pxToSvgSize(90) / 90})`"
        xlink:href="~@/assets/images/current_location.svg"
      />

    </svg>
  </div>
</template>

<script>
import map from '@/mixins/map.js';
import svgDefs from './decoration/defs.vue';
import mapImage from './map_image.vue';
import mapHeader from './map_header.vue';
import visualizationLayerLight from './visualization/layer/light.vue';
import visualizationLayerTemperature from './visualization/layer/temperature.vue';
import visualizationLayerHumidity from './visualization/layer/humidity.vue';
import visualizationLayerEco2 from './visualization/layer/eco2.vue';
import visualizationLayerSound from './visualization/layer/sound.vue';
import visualizationLayerWindSpeed from './visualization/layer/wind_speed.vue';

export default {
  components: {
    svgDefs,
    mapImage,
    visualizationLayerLight,
    visualizationLayerTemperature,
    visualizationLayerHumidity,
    visualizationLayerEco2,
    visualizationLayerSound,
    visualizationLayerWindSpeed,
    mapHeader
  },
  mixins: [map],
  props: {
    visualizationLayerType: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    currentFloor: ({ $store, currentFloorId }) => $store.getters['area/floorFind'](currentFloorId),
    currentFloorId: ({ $store }) => $store.state.current.floorId,
    currentBuilding: (vm) => vm.$store.getters['area/buildingFindByFloor'](vm.currentFloorId),
    currentBuildingId: ({ $store }) => $store.state.current.buildingId,
    svgElm: {
      get: ({ $store }) => $store.state.map.svgElm,
      set(elm) {
        this.$store.commit('map/getSvgElm', elm);
      },
    },
    viewBox: ({ mapAdjustSize }) => `0 -${mapAdjustSize.depth} ${mapAdjustSize.width} ${mapAdjustSize.depth}`,
    visualizationPinType: ({ $store }) => $store.state.map.visualizationPinType,
    isShowDetail: ({ $store }) => $store.state.destinationDetail.isShow,
    shiftMap: ({ $store }) => $store.state.map.shiftMap,
    isShowVisualizationLayer: ({ visualizationLayerType }) => visualizationLayerType !== 'default',
    mapAdjustSize: ({ currentBuilding, isShowVisualizationLayer }) => {
      return {
        width: currentBuilding.width,
        depth: currentBuilding.depth + (isShowVisualizationLayer ? 5 : 0),
      };
    },
  },
  watch: {
    currentFloorId(id) {
      const building = this.$store.getters['area/buildingFindByFloor'](id);
      this.$store.commit('current/setBuildingId', building.id);
      this.$store.dispatch('area/getFloorSpots', id);
      this.getDomInfomation();
      this.svgElm.style.opacity = 0;
      setTimeout(() => {
        this.svgElm.style.transition = 'opacity 0.5s linear';
        this.svgElm.style.opacity = 1;
        setTimeout(() => {
          this.svgElm.removeAttribute('style');
        }, 500);
      }, 0);
    },
  },
  created() {
    // NOTE: TAC.T CAFE & TAC.T TERRACE 固定表示なのでIDは固定値
    const floorID = 1;
    this.$store.commit('current/setFloorId', floorID);
    this.$store.dispatch('area/getFloorSpots', floorID);
  },
  mounted() {
    this.svgElm = this.$el.querySelector('svg');
    this.getDomInfomation();
  },
  methods: {
    getDomInfomation() {
      this.$store.dispatch('map/getFitOrientation');
      this.$store.dispatch('map/saveBaseDomRect');
    },
    clearDestinations() {
      this.$store.dispatch('searchResult/allClearDestinations');
    },
  },

};
</script>

<style scoped lang="scss">
svg {
  display: block;
  box-sizing: border-box;
  transform-origin: 0 0;
}
.visualizationPinLayer {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
}
.map-wrap {
  height: 100%;
  width: 100%;
  transition: transform 0.2s ease-out 0;
  &.shift-right {
    transform: translateX(550px);
  }
  position: relative;
}
</style>



// WEBPACK FOOTER //
// map.vue?ec7a8840